<template>
  <div class="page flex-col">
    <div class="group_1 flex-col">
      <div class="block_1 flex-col"></div>
      <div class="text-wrapper_1 flex-col">
        <span class="text_1">ARCTCO&nbsp;TECHNOLOGY&nbsp;LTD</span>
        <span class="text_2">
          Improve&nbsp;the&nbsp;quality&nbsp;and&nbsp;efficiency&nbsp;of&nbsp;financial&nbsp;services&nbsp;through&nbsp;technology,&nbsp;and&nbsp;provide&nbsp;convenient&nbsp;financial&nbsp;lending&nbsp;services&nbsp;to&nbsp;users&nbsp;in&nbsp;need
        </span>
      </div>
      <div class="block_2 flex-col"></div>
      <div class="block_3 flex-col"></div>
      <div class="block_4 flex-row justify-between">
        <div class="box_1 flex-col"></div>
        <div class="box_2 flex-col"></div>
      </div>
      <div class="block_5 flex-col"></div>
      <div class="image-text_1 flex-row justify-between">
        <img
          class="label_1"
          referrerpolicy="no-referrer"
          src="./assets/img/SketchPng04f608b8330c5516b9607fbb7cf7464d7853e2551cbbb82a00b25aaa4b015246.png"
        />
        <span class="text-group_1">Postal&nbsp;code:&nbsp;00233</span>
      </div>
      <div class="image-text_2 flex-row justify-between">
        <img
          class="label_2"
          referrerpolicy="no-referrer"
          src="./assets/img/SketchPngd70bdfd4286c150dfa268af61b45f26ef746840c182b7c7e898822c08c8dacef.png"
        />
        <span class="text-group_2">
          Address:&nbsp;H/NO&nbsp;A140/,&nbsp;ASAFOATSE&nbsp;DJAN&nbsp;STREET,&nbsp;OSU,&nbsp;Accra,&nbsp;Accra,&nbsp;GREATER&nbsp;Accra,&nbsp;Ghana
        </span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      constants: {}
    };
  },
  methods: {}
};
</script>
<style scoped lang="scss" src="./assets/index.scss" />